import "./style.scss";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

const Footer = () => {
  return (
    <footer className="footer mt-40">
      <div className="container">
        <div className="footer-main py-20 flex justify-between align-center">
          <p className="footer-main_copy font-14">
            © {new Date().getFullYear()}{" "}
            <a href="https://sensorium.hr/" className="font-14">
              Sensorium d.o.o.
            </a>
          </p>
          <div className="footer-main_links flex gap-20">
            <Link to="/cjenik" className="font-14">
              <FormattedMessage id="price_list" />
            </Link>
            {/* /gradovi is served by the SEO service (not a SPA route) -> plain anchor for a
                full navigation through Caddy, not react-router. */}
            <a href="/gradovi" className="font-14">
              <FormattedMessage id="cities" />
            </a>
            <Link to="/privatnost" className="font-14">
              <FormattedMessage id="privacy_policy" />
            </Link>
            <Link to="/uvjeti" className="font-14">
              <FormattedMessage id="terms_of_service" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
